// extracted by mini-css-extract-plugin
export default {"pageWrap":"od-z","fullWidth":"pd-z","heading":"qd-z","fullBleed":"rd-z","hidden":"sd-z"};